module.exports = __webpack_public_path__ + "static/media/exhibition_icon_img.a4c3e049.svg";